// PublicRoute.js
import React from "react";
import { Navigate } from "react-router-dom";
import { isAuthenticated } from "../../Services/tokenHelper";

const PublicRoute = ({ children }) => {
  return isAuthenticated() ? <Navigate to="/dashboard" replace /> : children;
};

export default PublicRoute;
